
import Vue from 'vue';

export default Vue.extend({
  props: ['nombre', 'email', 'estado'],
  data() {
    return {
      password: '*******',
    };
  },
});
